export { isEmailOnlyUserToken } from '../src/helpers/emailOnlyHelpers';
